/* eslint-disable max-lines */
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
const EDIT_TYPE = {
    EDIT: 2,
    CANCEL: -3
};

export const config = {
    name: 'revenueVersion',
    searchFields: [
        {
            name: '预测月份',
            value: 'periodMonth',
            type: 'date',
            timeType: 'month',
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
            isFixed: true,
            span: 4
        },
        {
            name: '预测版本',
            value: 'forecastVersionCode',
            type: 'input',
            isFixed: true,
            span: 4
        },
        {
            name: '状态',
            value: 'statusList',
            type: 'select',
            optionNum: 'CRM_FORECAST_VERSION_STATUS',
            multiple: true,
            isFixed: true,
            span: 4
        },
        {
            name: '创建日期',
            value: 'createTimeFixed',
            type: 'time',
            time: 'daterange',
            format: 'yyyy-MM-dd',
            startPlaceholder: '创建日期从',
            endPlaceholder: '创建日期到',
            isFixed: true,
            span: 8
        }
    ],
    selection: false,
    index: false,
    columns: [
        {
            label: '预测月份',
            prop: 'periodMonth',
            type: 'slot',
            slot: true,
            editSlot: true,
            mustFill: true,
            fixed: 'left',
            width: 115
        },
        {
            label: '预测版本',
            prop: 'forecastVersionCode',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 70
        },
        {
            label: '滚动预测月数',
            prop: 'rollMonths',
            type: 'slot',
            tooltip: '定义需滚动预测月数，预测年月内不允许更改',
            editSlot: true,
            mustFill: true,
            width: 110
        },
        {
            label: '状态',
            prop: 'versionStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'CRM_FORECAST_VERSION_STATUS',
            width: 80
        },
        {
            label: '跑数情况',
            prop: 'syncResult',
            width: 70
        },
        {
            label: '待办标题',
            prop: 'todoTitle',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 150
        },
        {
            label: '待办内容',
            prop: 'todoContent',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 150
        },
        {
            label: '待办开始时间',
            prop: 'todoStartTime',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 140
        },
        {
            label: '待办结束时间',
            prop: 'todoEndTime',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 140
        },
        {
            label: '待办推送状态',
            prop: 'todoSendStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'CRM_TODO_SEND_STATUS',
            width: 90
        },
        {
            label: '创建人',
            prop: 'createUserName',
            width: 70
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 150
        },
        {
            label: '修改人',
            prop: 'updateUserName',
            width: 70
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 150
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 115, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '审核',
                event: 'verify',
                displayRule: (row) => {
                    const isAuth = otherUtils.getHasAuth(btnAuthority.revenueVersion.verify);
                    return +row.edit === EDIT_TYPE.CANCEL && isAuth && +row.versionStatus === 0;
                }
            },
            {
                label: '推送待办',
                event: 'send',
                displayRule: (row) => {
                    const isAuth = otherUtils.getHasAuth(btnAuthority.revenueVersion.send);
                    return +row.edit === EDIT_TYPE.CANCEL && isAuth && row.todoSendStatus === 'draft';
                }
            },
            {
                label: '重推待办',
                event: 'resend',
                displayRule: (row) => {
                    const isAuth = otherUtils.getHasAuth(btnAuthority.revenueVersion.resend);
                    return +row.edit === EDIT_TYPE.CANCEL && isAuth && ['failed', 'completed'].includes(row.todoSendStatus);
                }
            }
        ]
    },
    rowEdit: otherUtils.getHasAuth(btnAuthority.revenueVersion.save),
    rowDbClickFun: (row) => false, // 是否双击编辑
    disableEditFun: (row) => { // 编辑按钮禁用
        const isAuth = otherUtils.getHasAuth(btnAuthority.revenueVersion.edit);
        return !isAuth || (+row.versionStatus !== 0 && !['draft', 'failed', 'completed'].includes(row.todoSendStatus));
    }
};
